import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import SectionHeading from '@/components/base/SectionHeading';
import { allArticles } from '@/lib/content';

export default function LatestSection() {
  const latest = allArticles.slice(0, 5);
  const hot = [...allArticles].sort((a, b) => b.views - a.views).slice(0, 5);

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto grid max-w-content gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-8">
          <SectionHeading eyebrow="最新观察" title="持续更新的线索整理" />
          <div className="space-y-6">
            {latest.map((article) => (
              <ArticleCard key={article.id} article={article} variant="horizontal" />
            ))}
          </div>
          <Link
            to="/insight"
            className="mt-8 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-3 font-label text-sm text-background-50 transition-colors hover:bg-primary-700"
          >
            查看全部观察
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <aside className="lg:col-span-4">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
            <div className="mb-5 flex items-center gap-2">
              <i className="ri-fire-line text-lg text-primary-600" />
              <h3 className="font-heading text-base font-bold text-foreground-950">热门阅读</h3>
            </div>
            <div className="space-y-5">
              {hot.map((article) => (
                <ArticleCard key={article.id} article={article} variant="minimal" />
              ))}
            </div>
          </div>

          <div className="mt-6 rounded-lg bg-foreground-950 p-5 md:p-6">
            <i className="ri-megaphone-line text-2xl text-accent-400" />
            <h3 className="mt-3 font-heading text-lg font-bold text-background-50">你的经历，也是别人的参考</h3>
            <p className="mt-2 text-sm leading-relaxed text-background-300">
              我们接受匿名投稿，发布前会做脱敏处理，只在必要时与你确认细节。
            </p>
            <Link
              to="/contact"
              className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              前往投稿
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}